<template>
  <div class="p-px-4" style="direction:rtl;">
    <div>
      <span
        >{{ __(contact.IsMain ? "Main contact" : "Secondary contact") }}:</span
      >
      <span class="contact-data">
        {{ contact.firstName }} - {{ contact.LastName }}
      </span>
    </div>
    <div class="p-mb-1">
      <span>{{ __("First name") }}:</span>
      <span class="contact-data">{{ contact.firstName }}</span>
    </div>
    <div class="p-mb-1">
      <span>{{ __("Last name") }}:</span>
      <span class="contact-data">{{ contact.LastName }}</span>
    </div>
    <div class="p-mb-1">
      <span>{{ __("role") }}:</span>
      <span class="contact-data">{{ contact.Position }}</span>
    </div>
    <div class="p-d-flex p-jc-between p-mb-1">
      <div>
        <span>{{ __("Mobile") }}:</span>
        <span class="contact-data">{{ contact.TelMobile }}</span>
      </div>
      <i-contacts-group
        :data="{
          phone: contact.TelMobile,
          whatsapp: contact.TelMobile,
          sms: contact.TelMobile,
        }"
      />
    </div>
    <div class="p-mb-1">
      <span>{{ __("Office phone") }}:</span>
      <span class="contact-data">{{ contact.TelWork }}</span>
    </div>
    <div class="p-mb-1">
      <span>{{ __("Fax") }}:</span>
      <span class="contact-data">{{ contact.FaxWork }}</span>
    </div>
    <div class="p-d-flex p-jc-between p-mb-1">
      <div>
        <span>{{ __("Email") }}:</span>
        <span class="contact-data">{{ contact.Email }}</span>
      </div>
      <i-contacts-group
        :data="{
          mail: contact.Email,
        }"
      />
    </div>
    <div class="p-mb-1">
      <span>{{ __("Address") }}:</span>
      <span class="contact-data">{{ contact.Address }}</span>
    </div>
  </div>
</template>

<script>
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import { __ } from "@/plugins/i18n";

export default {
  props: {
    contact: {},
  },
  emits: ["DeleteContact"],
  methods: {
    deleteInDB() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("ID", this.contact.id, apiPType.Int),
      ];
      callProc("WorkerApp_DeleteSuppliersSub", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("Contact deleted successfully"));
            setTimeout(() => {
              this.$emit("DeleteContact", this.contact.id);
            }, 1000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteSuppliersSub");
        });
    },
  },
  computed: {
    Delete() {
      return this.contact.Delete;
    },
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
  watch: {
    Delete() {
      if (this.Delete) this.deleteInDB();
    },
  },
};
</script>

<style scoped>
.contact-data {
  color: var(--color-accent);
  margin-right: 0.5rem;
}
</style>
